import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          deletion: {
            '{}': {
              ids: {
                '[]': [
                  {
                    '@$': 'activityId',
                  },
                ],
              },
              modelId: 'ent:!subaward_monitor_acts:!activity',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
